import React, { useState, createRef, useEffect } from 'react';
import styles from './styles.module.scss';
import Form from '../Form';

// import Api from '@/api/index';
import Api from '../../api';
// import CheckNumeric from '@/functions/CheckNumeric';
// import LoginFunction from '@/functions/LoginFunction';
// import AppImage from '../AppImage';
import Cookies from 'js-cookie';
// import { AdminContext } from '@/context/AdminContext';
import { useContext } from 'react';

// import AppFormFourInput from '../AppFormFourInput';
// import toEnglishDigits from '@/functions/toEnglishDigits';
// import Loader from '../Loader';
import { FormHead, FormSubHead } from '../FormHead';
import AppFormInput from '../AppFormInput';
import { AdminContext } from '../../context/AdminContext';
import toEnglishDigits from '../../functions/toEnglishDigits';
import CheckNumericType from '../../functions/CheckNumeric';
import loginLogo from '../../../../assets/imgs/login/loginLogo.svg';
import CookieFunction from '../../functions/cookieFunction';
import LoginFunction from '../../functions/LoginFunction';

const SignUpCode = ({
  setLevel2,
  setLevel3,
  newuser,
  setSignUpModal,
  setLoginInformation,
}) => {
  const {
    // setShowModal,
    setLogin,
    // setLoginFromSignUp,
    setUserId,
    // setTemporaryInfo,
    themeColor,
    setTrigger,
    content,
  } = useContext(AdminContext);
  const [user, setUser] = useState(newuser);
  const [showErrorcode, setShowErrorcode] = useState(false);
  const [serverError, setServerError] = useState('');
  const [c1, setC1] = useState('');
  const [c2, setC2] = useState('');
  const [c3, setC3] = useState('');
  const [c4, setC4] = useState('');
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [codeNotSend, setCodeNotSend] = useState(false);
  const [pressEnter, setPressEnter] = useState(false);
  const [loading, setLoading] = useState(false);

  const button = createRef();

  // useEffect(() => {
  //   if ('OTPCredential' in window) {
  //     window.addEventListener('DOMContentLoaded', (e) => {
  //       const input = document.querySelector(
  //         'input[autocomplete="one-time-code"]'
  //       );
  //       if (!input) return;
  //       const ac = new AbortController();
  //       const form = input.closest('form');
  //       if (form) {
  //         form.addEventListener('submit', (e) => {
  //           ac.abort();
  //         });
  //       }
  //       navigator.credentials
  //         .get({
  //           otp: { transport: ['sms'] },
  //           signal: ac.signal,
  //         })
  //         .then((otp) => {
  //           input.value = otp.code;
  //           alert(otp.code);
  //           if (form) form.submit();
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //     });
  //   }
  // });

  const submitFormFunction = (e) => {
    e.preventDefault();
    if (pressEnter == false) {
      setPressEnter(true);

      let code = c1 + c2 + c3 + c4;

      if (code?.length === 0) {
        code = user?.code;
      }

      e.preventDefault();
      let check;
      // check = CheckNumeric(code);
      let english = toEnglishDigits(code);
      console.log('check', check, english, code);
      // console.log("value", user?.code?.charAt(0), CheckNumeric(user?.code?.charAt(0)))
      check = CheckNumericType(english);
      // console.log('check', check, code?.length);
      if (check == false || code?.length != 4) {
        setShowErrorcode(true);
      } else {
        setShowErrorcode(false);
        setLoading(true);
        Api.userSignUp({
          username: `${newuser?.mobile}`,
          code: `${code}`,
          deviceType: 'site',
          countryCode: '+' + `${newuser?.countryCode}`
        })
          .then((res) => {
            // setTemporaryInfo(res);
            if (
              typeof window !== 'undefined' &&
              typeof document !== 'undefined'
            ) {
              // Cookies.set('ochattToken', res.data.response.accessToken, {
              //   expires: 365,
              // });
              // Cookies.set('userAuthOchatt', res.data.response.channelId, {
              //   expires: 365,
              // });

              // Cookies.set('signup', true);
              // Cookies.set('fromSignup', true);
              // Cookies.set('user', res.data.response.id, {
              //   expires: 365,
              // });
              // setUserId(Cookies.get('user'));
              // setLogin(Cookies.get('ochattToken'));
              // // setLoginFromSignUp(true);
              setLevel2(false);
              setLevel3(true);
              // setShowModal(false);
              // LoginFunction(true);
              setLoading(false);
              // setSignUpModal(false);
              setPressEnter(false);
              setLoginInformation(res);
              // CookieFunction(
              //   'set',
              //   'ochattToken',
              //   res.data.response.accessToken
              //   // () => {
              //   //   setLogin(CookieFunction('get', 'ochattToken'));
              //   // }
              // );
              // CookieFunction('set', 'userAuthOchatt', res.data.response.uuid);
              // CookieFunction(
              //   'set',
              //   'userAuthOchattId',
              //   res.data.response.channelId
              // );

              // // Cookies.set('ochattToken', res.data.response.accessToken, {
              // //   expires: 365,
              // // });
              // // Cookies.set('userAuthOchatt', res.data.response.channelId, {
              // //   expires: 365,
              // // });

              // // setLogin(Cookies.get('ochattToken'));
              // // Cookies.remove('fromSignUp');
              // // Cookies.set('user', res.data.response.id, {
              // //   expires: 365,
              // // });

              // CookieFunction('set', 'user', res.data.response.id);
            }
            // setTrigger('opensetting');
          })
          .catch((err) => {
            setPressEnter(false);
            setServerError(err?.response?.data?.message);
            setLoading(false);
          });
      }
    }
  };

  const changeUsercode = (e) => {
    setUser({ ...newuser, code: e.target.value });
    setServerError('');
    setShowErrorcode(false);
    setPressEnter(false);
  };
  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          setCodeNotSend(true);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const resendCode = () => {
    if (minutes == 0 && seconds == 0) {
      setServerError('');
      Api.userSendCode({ username: `${newuser.mobile}`,           deviceType: 'site',
      countryCode: '+' + `${newuser?.countryCode}` })
        .then((res) => {
          // console.log('res', res);
        })
        .catch((err) => {
          setPressEnter(false);
        });

      setCodeNotSend(false);
      setMinutes(1);
      setSeconds(0);
    }
  };

  return (
    <div className={`${styles.container}`}>
      <FormHead className="mobile-view" title="ثبت‌نام" />
      <FormSubHead
        serverError={serverError}
        title={content?.signup?.code?.title}
        description={content?.signup?.code?.description}
      />

      <Form
        onSubmit={submitFormFunction}
        user={user}
        extraStyleButton={{
          marginTop: 'auto',
          marginBottom: '0',
          width: '100%',
        }}
        className={styles.formStyle}
        //</div>    disabled={!(c1.length > 0 && c2.length && c3.length && c4.length)}
        buttonText={content?.signup?.code?.button}
        extraButtonClass={styles.formButton}
        loadingU={loading}
      >
        {/* <p>new input</p>
        <input autoComplete='one-time-code' className={`bgF5`} /> */}

        {/* <div className="mobile-view">
          <AppFormFourInput
            inputStyle={styles.inputStyle}
            showError={showErrorcode}
            title={'کد ارسالی'}
            error={'کد دریافتی را به صورت عدد چهار رقمی وارد کنید.'}
            showInput={false}
            c1={c1}
            c2={c2}
            c3={c3}
            c4={c4}
            setC1={setC1}
            setC2={setC2}
            setC3={setC3}
            setC4={setC4}
            button={button}
            setPressEnter={setPressEnter}
          />
        </div> */}
        <div className="w-full">
          <AppFormInput
          targetType='num'
            onChange={changeUsercode}
            inputWidth="420px"
            inputStyle={styles.inputStyle}
            showError={showErrorcode}
            title={content?.signup?.code?.input?.title}
            error={content?.signup?.code?.input?.error}
            wrapperStyle={`${styles.wrapper} borderBottom`}
            className={styles.inputContainer}
            value={user?.code}
          />
        </div>

        <div className={`w-full`}>
          <div
            className={`flex flex-row justify-between items-center w-full h-auto py-[8px] mx-auto w-full`}
          >
            <>
              <span
                className={`${styles.sendCodeText} ${
                  codeNotSend ? styles.active : styles.unActive
                }`}
                onClick={() => resendCode()}
              >
                {content?.signup?.code?.resend}
              </span>
            </>

            <>
              <span
                className={`${styles.sendCodeText} ${
                  themeColor != 'white' && 'textWhite'
                }`}
              >
                {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
              </span>
            </>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default SignUpCode;
